module.exports = function() {
  return new Worker(__webpack_public_path__ + "5915dda41f4a3df132f2.worker.js");
};